import { render, staticRenderFns } from "./HighlightVideoPlayer.vue?vue&type=template&id=047f1ede&scoped=true"
import script from "./HighlightVideoPlayer.vue?vue&type=script&lang=js"
export * from "./HighlightVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./HighlightVideoPlayer.vue?vue&type=style&index=0&id=047f1ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f1ede",
  null
  
)

export default component.exports